__webpack_require__.p = "/position-observer/account-setup/";